import React, { useState, useEffect } from 'react';
import DeckGL from '@deck.gl/react';
import { WebMercatorViewport } from '@deck.gl/core';
import ReactMapGL from 'react-map-gl';
import { ArcLayer } from '@deck.gl/layers';
import mapboxgl from 'mapbox-gl';
import MapUI from './contents/MapUI';

mapboxgl.accessToken = 'pk.eyJ1Ijoicm9yaW9wMiIsImEiOiJjbGVmY2p3Y3QwcGsyM3VxcXR3MzVmdGNqIn0.bKksh0sQpm6vQuV-tZjj7g';

function App({setShow}) {
  const [mapData, setMapData] = useState([]);

  let data = {}
  data['color'] = '';
  data['cluster_id'] = '';

  useEffect(() => {
      (async () => {
        await fetch("/api/getShipping", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ data })
        })
          .then(res => {
            return res.json()
          })
          .then(data => {
            setMapData(data);
          })
          .catch(error => console.log(error));
      })()
  }, []);

  const [viewport, setViewport] = useState({
    longitude: 126.9779,
    latitude: 37.5665,
    zoom: 9,
    pitch: 60,
  });

  const arcLayer = new ArcLayer({
    id: 'arc-layer',
    data: mapData,
    getSourcePosition: d => d.sourcePosition,
    getTargetPosition: d => d.targetPosition,
    getWidth: 1,
    getSourceColor: [255, 0, 0],
    getTargetColor: [0, 255, 0]
  });

  const onViewportChange = viewport => {
    setViewport(viewport);
  };

  const deckGLView = new WebMercatorViewport({
    width: viewport.width,
    height: viewport.height,
    longitude: viewport.longitude,
    latitude: viewport.latitude,
    zoom: viewport.zoom,
    bearing: viewport.bearing,
    pitch: viewport.pitch
  });

  return (
    <DeckGL
      viewState={viewport}
      layers={[arcLayer]}
      getCursor={() => 'default'}
      onViewStateChange={({ viewState }) => {
        setViewport(viewState);
      }}
      controller={true}
    >
      <ReactMapGL
        {...viewport}
        width="100%"
        height="100%"
        mapStyle="mapbox://styles/mapbox/light-v11"
        mapboxApiAccessToken={mapboxgl.accessToken}
        onViewportChange={onViewportChange}
        viewState={deckGLView}
      />
      <MapUI setShow={setShow} />
    </DeckGL>
  );
}

export default App;
